@use '@lib/assets/styles/main.scss' as *;

.block {
  margin-top: 24px;
}

.cellWithValidityHint {
  & + .cellWithValidityHint {
    margin-top: 8px;
  }
}

.description {
  margin-top: 16px;
  color: $gray700;
}

.table {
  * + & {
    margin-top: 32px;
  }
}

.criticalRow {
  background-color: $error100 !important;
}

.warningRow {
  background-color: $warning100 !important;
}

.emptyState {
  margin-top: 24px;
}

.chipsRow {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.optionRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.grayText {
  color: $gray400;
}

.labelBox {
  margin-bottom: 8px;
}

.optionsList {
  & > * + * {
    margin-top: 2px;
  }
}
